export class SubscribeApi {
    /**
     * @param {number} userId
     * @param {number} starId
     * @param {string} packageName
     * @param {string|null} redeemCode
     * @param {string} accessToken
     * @returns {Response}
     */
    async fetch(userId, starId, packageName, accessToken, redeemCode = null) {
        return await window.fetch("/api/stars/subscribe", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                userId,
                starId,
                packageName,
                redeemCode,
                accessToken,
            }),
        })
    }
}
